import React, { useEffect, useRef, useState } from "react";
import i18n from "i18next";
import { baseUrl } from "../../../helpers/constants";
import authService from "../../api-authorization/AuthorizeService";
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { useNavigate } from "react-router-dom";
import { Button, Text } from "@fluentui/react-components";
import {
  ArrowLeftRegular,
  ArrowRightRegular,
  InfoRegular,
  PersonKeyRegular,
} from "@fluentui/react-icons";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import Header from "../Header";

function About(props: any) {
  const module = window.location.search
    .substring(window.location.search.indexOf("&module=") + 9)
    .toUpperCase();

  const [benutzer, setBenutzer] = useState();
  const [roles, setRoles] = useState<string[]>([]);
  const [requestedRoles, setRequestedRoles] = useState<any[]>([]);

  const getUser = () => {
    authService.getUser().then((user: any) => {
      if (user) {
        fetchWrapper
          .getWithAuth(`${baseUrl}/api/account/getcurrentuser`)
          .then((result) => {
            setBenutzer(result);
            // Bin eingeloggt, wir können die Rollen des Benutzers abfragen:
            fetchWrapper
              .getWithAuth(`${baseUrl}/api/account/getmyroles`)
              .then((result) => {
                setRoles(result);
              })
              .catch((error) => {});

            fetchWrapper
              .getWithAuth(`${baseUrl}/api/account/GetMyRequestedRoles`)
              .then((result) => {
                setRequestedRoles(result);
              })
              .catch((error) => {});
          });
      }
    });
  };

  useEffect(() => {
    getUser();
  }, []);

  const navigate = useNavigate();

  const hasRole =
    roles && roles.some((x) => x.toLowerCase() == module.toLowerCase());
  const hasRequested =
    requestedRoles &&
    requestedRoles.some((x) => x.toLowerCase() == module.toLowerCase());
  const isLoggedIn = benutzer ? true : false;

  const onClick = () => {
    if (isLoggedIn && hasRole) {
      navigate(link);
    } else if (isLoggedIn && !hasRole) {
      requestRole();
    } else {
      navigate("/account/login?modul=" + module);
    }
  };

  const requestRole = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/requestrole?role=${module}`)
      .then(() => {
        getUser();
      })
      .catch((error) => {});
  };

  let buttonText = "";

  if (hasRole && !hasRequested) {
    buttonText = i18n.t<string>("next");
  } else if (!hasRole && hasRequested) {
    buttonText = i18n.t<string>("requestedRole"); // Angefragt ?
  } else if (!hasRole && !hasRequested) {
    buttonText = i18n.t<string>("requestRole"); // Anfragen ?
  }

  const disable = () => {
    if (roles.includes("Toolbox") && module == "PARTNER") {
      return true;
    } else if (hasRequested) {
      return true;
    } else {
      return false;
    }
  };

  let link = "/";

  switch (module) {
    case "PARTNER":
      link = "";
      break;
    case "TOOLBOX":
      link = "/mytoolbox";
      break;
    case "ACADEMY":
      link = "/academy";
      break;
    case "CONFIGURATOR":
      link = "/configuratorst";
      break;
    case "CATALOG":
      link = "/quickfinder";
      break;
  }

  return (
    <div>
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            <Button
              icon={<InfoRegular fontSize={24} color="#ff6600" />}
              appearance="subtle"
            >
              {i18n.t<string>("about").toLocaleUpperCase() + " - " + module}
            </Button>
          </StackShim>
        }
      />

      <div className="lueb-ImageBlock">
        <img
          alt="Home Teaser"
          className="lueb-ImageRounded"
          src={`${baseUrl}/IMAGES/ABOUT_${module}.JPG`}
        />
      </div>
      <div className="lueb-ContentBlock">
        <h4>{i18n.t<string>("homeTeaserCallOutTitle" + module)}</h4>
        <Text block>{i18n.t<string>("homeTeaserCallOutText" + module)}</Text>
        {i18n.language.includes("de") && (
          <div className="lueb-listWithPlusIcon">
            {module == "CONFIGURATOR" && (
              <div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Wir unterstützen Sie bei der Konfiguration mit anschaulichen
                    Bildern, die Ihnen die Eingabe Ihrer technischen Parameter
                    erleichtert. Sie erhalten sowohl 2D-Zeichnungen inklusive
                    aller technischen Daten der einzelnen Systemkomponenten als
                    auch 3D-Volumenmodelle des Gesamtwerkzeugs.
                  </Text>
                </div>

                <div style={{ marginTop: 10 }}>
                  <Text>
                    Sie können Ihre Konfiguration direkt aus dem L.SP3
                    Configurator bei uns anfragen und erhalten in kürzester Zeit
                    ein Angebot von unserem Vertriebsteam. Alternativ können Sie
                    Ihre Konfiguration in Ihrem Account abspeichern, jederzeit
                    wieder aufrufen und zu einem späteren Zeitpunkt anfragen.
                  </Text>
                </div>
                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>
                    Gesamtes Schraubsystem konfigurierbar – vom Zahnrad bis zur
                    Antriebsmaschine
                  </li>
                  <li>
                    Einfache Handhabung: Schritt für Schritt zum individuellen
                    Schraubsystem
                  </li>
                  <li>Zugriff auf 2D-Produktzeichnungen und 3D Daten</li>
                  <li>
                    Antriebsmaschinen zahlreicher Toolhersteller konfigurierbar
                  </li>
                  <li>Gesamtkonfiguration speichern und jederzeit abrufen</li>
                  <li>
                    Schraubsystem-Konfiguration direkt anfragen und schnell ein
                    Angebot erhalten
                  </li>
                  <li>Online auf mobilen Endgeräten verfügbar</li>
                </ul>
                <Text>
                  Das LÜBBERING Team wünscht Ihnen viel Spaß beim Konfigurieren
                  Ihres individuellen L.SP3 Schraubsystems.
                </Text>
              </div>
            )}

            {module == "CATALOG" && (
              <div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Nutzen Sie unsere Schnellsuche innerhalb des gesamten L.SP3
                    Produktportfolios und finden Sie heraus, ob der
                    Schraubartikel mit Ihren gewünschten Parametern in unserem
                    L.SP3 Standardprogramm erhältlich ist. Sie können offene und
                    geschlossene Flachabtriebe suchen – wahlweise in der
                    Standard- oder Inline-Bauform. Weiterhin bieten wir Ihnen
                    eine Suche nach Abtriebszahnrädern mit unterschiedlichen
                    Abtriebsprofilen. Zur besseren Orientierung sehen Sie bei
                    Ihrer Eingabe auch nützliche Bilder.
                  </Text>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Im Ergebnis haben Sie zu Ihrem gesuchten Artikel alle
                    technischen Daten im Überblick und können sich auch die
                    jeweilige Produktzeichnung dazu ansehen. Damit der Artikel
                    nicht in Vergessenheit gerät, können Sie ihn ganz einfach
                    auf Ihre Bedarfsliste setzen und bei LÜBBERING anfragen.
                  </Text>
                </div>
                Probieren Sie es aus und finden Sie hier unsere neuesten
                Produkte aus dem Bereich Schraubtechnik.
                <div style={{ marginTop: 10 }}>
                  <Text></Text>
                </div>
                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>
                    Schneller Überblick über das gesamte L.SP3 Produktportfolio
                  </li>
                  <li>Schnellzugriff auf alle L.SP3 Schraubtechnik-Artikel</li>
                  <li>
                    Einfache Verfügbarkeitskontrolle durch Eingabe Ihrer
                    technischen Anforderungen
                  </li>
                  <li>Technische Daten und Produktzeichnungen</li>
                  <li>Schraubtechnik-Artikel vormerken oder direkt anfragen</li>
                  <li>
                    Einzelne Artikel einfach und bequem suchen – keine
                    Gesamtkonfiguration notwendig
                  </li>
                  <li> Einfache Handhabung</li>
                </ul>
                <Text>
                  Das LÜBBERING Team wünscht Ihnen viel Spaß bei Ihrer
                  Produktsuche.
                </Text>
              </div>
            )}

            {module == "TOOLBOX" && (
              <div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Sie haben LÜBBERING Schraub- oder Bohrsysteme im Einsatz?
                    Dann legen Sie Ihre eigene LÜBBERING TOOLBOX an und
                    profitieren Sie von dem schnellen Zugriff auf
                    Produktzeichnungen, Dokumente und vieles Mehr. Sie können
                    auch Ihre Produktdaten um eigene Daten wie Dokumente, Fotos
                    oder Videos erweitern und diese innerhalb eines Teams,
                    welches Sie individuell definieren können, teilen.
                  </Text>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Sie sind LÜBBERING Partner? Registrieren Sie sich für die
                    Partner Lounge. Hier können Sie Ihre Schraub- oder
                    Bohrsysteme auftragsbezogen verwalten und erhalten Zugriff
                    auf alle relevanten Produktdaten für eine noch bessere
                    Kundenbetreuung.
                  </Text>
                </div>
                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>Übersicht Ihrer Schraub- oder Bohrsysteme</li>
                  <li>Einsatzort der Schraub- oder Bohrsysteme hinterlegen</li>
                  <li>
                    Alle technischen Produktdaten jederzeit und überall abrufbar
                  </li>
                  <li>Produktansichten in 3D</li>
                  <li>Ersatzteillisten | Stücklisten</li>
                  <li>Komfortable Ersatzteilbeschaffung mit Merklisten</li>
                  <li>
                    Vorbeugende Wartungsempfehlungen für Ihre Schraub- oder
                    Bohrsysteme
                  </li>
                  <li>
                    Erhebliche Zeitersparnis durch schnellen Informationsfluss
                  </li>
                  <li>
                    Teams bilden und Produktinformationen untereinander teilen
                  </li>
                </ul>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Sie sind LÜBBERING Partner? Registrieren Sie sich über MY
                    TOOLBOX für die PARTNER LOUNGE. Hier können Sie Ihre
                    Schraub- oder Bohrsysteme analog zur MY TOOLBOX
                    auftragsbezogen verwalten und erhalten Zugriff auf alle
                    relevanten Produktdaten für eine noch bessere
                    Kundenbetreuung.
                  </Text>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Das LÜBBERING DIGITAL Team wünscht Ihnen viel Spaß beim
                    Füllen Ihres persönlichen LÜBBERING Werkzeugkastens.
                  </Text>
                </div>
              </div>
            )}

            {module == "PARTNER" && (
              <div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Sie sind LÜBBERING Endkunde? Dann registrieren Sie sich in
                    My Toolbox. Hier können Sie Ihre Schraub- oder Bohrsysteme
                    verwalten. Sie haben Zugriff auf alle relevanten
                    Produktdaten für eine verbesserte Kundenbetreuung.
                  </Text>
                </div>

                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>
                    Einfache und übersichtliche auftragsbezogene
                    Werkzeugverwaltung
                  </li>
                  <li>
                    Produkt- und Bestelldaten im Überblick – Schraub- oder
                    Bohrsysteme inklusive Antriebsmaschine
                  </li>
                  <li>
                    Alle technischen Produktdaten jederzeit und überall abrufbar
                  </li>
                  <li>Produktansichten in 3D</li>
                  <li>Ersatzteillisten | Stücklisten</li>
                  <li>Komfortable Ersatzteilbeschaffung mit Merklisten</li>
                  <li>
                    Erhebliche Zeitersparnis durch schnellen Informationsfluss
                  </li>
                  <li>
                    Teams bilden und Produktinformationen untereinander teilen
                  </li>
                </ul>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Das LÜBBERING DIGITAL Team wünscht Ihnen viel Freude bei der
                    Nutzung unserer Partner Lounge für eine optimale
                    Kundenbetreuung.
                  </Text>
                </div>
              </div>
            )}

            {module == "ACADEMY" && (
              <div>
                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>
                    Überblick über das Schulungsangebot der LÜBBERING Academy
                  </li>
                  <li>
                    Schulungs- und Workshop-Termine direkt anfragen und ein
                    Angebot erhalten
                  </li>
                  <li>
                    Personalisierter Zugriff auf umfangreiche
                    Schulungsunterlagen und Videos
                  </li>
                  <li>Verwaltung der eigenen Schulungszertifikate</li>
                  <li>Empfehlung für eine Auffrischung der Schulungsinhalte</li>
                  <li>Expertenwissen direkt vom Hersteller</li>
                </ul>
              </div>
            )}
          </div>
        )}
        {i18n.language.includes("en") && (
          <div className="lueb-listWithPlusIcon">
            {module == "CONFIGURATOR" && (
              <div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    While you configure your system, we support you with
                    descriptive pictures to facilitate the entry of the
                    technical parameters. You will receive 2D drawings including
                    the technical data of each system component, as well as
                    3D-CAD models of the complete tool.
                  </Text>
                </div>

                <div style={{ marginTop: 10 }}>
                  <Text>
                    You can submit a request for quotation directly from the
                    L.SP3 Configurator and will then receive a quotation from
                    our sales team shortly after. Alternatively, you can save
                    your configuration on your account, call it up at any time
                    and request a quotation later.
                  </Text>
                </div>
                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>
                    Complete fastening system configurable – from output socket
                    gear up to drive unit
                  </li>
                  <li>
                    Easy to use: step by step to your individual fastening
                    system
                  </li>
                  <li>Access to 2D-product drawings and 3D data</li>
                  <li>
                    Adjustable to drive machines of numerous tool manufacturers
                  </li>
                  <li>
                    Complete configuration can be saved and called up at any
                    time
                  </li>
                  <li>
                    Request the fastening system configuration directly and
                    receive a quotation quickly
                  </li>
                  <li>Available online on your mobile device</li>
                </ul>
                <Text>
                  Enjoy configuring your individual L.SP3 fastening system.
                </Text>
              </div>
            )}

            {module == "CATALOG" && (
              <div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Use the quick search facility to explore the complete L.SP3
                    product portfolio and find out if the product with your
                    specific parameters is available. You can search for open
                    and closed geared offset heads – available as a standard or
                    inline model. In addition, you will be able to search for
                    output socket gears with various output profiles. Helpful
                    pictures appear whenever you input data in order to guide
                    you.
                  </Text>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    In the end, you will have gained access to all the technical
                    data of the article and the respective product drawing. In
                    order to find the article again, you can bookmark it on the
                    requirements list or request a quotation from LÜBBERING.
                  </Text>
                </div>
                Try it and use this tool to find the latest products in our
                fastening system range.
                <div style={{ marginTop: 10 }}>
                  <Text></Text>
                </div>
                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>Quick overview of the complete L.SP3 product range</li>
                  <li>
                    Quick access to our L.SP3 fastening technology articles in
                    order to check availability
                  </li>
                  <li>
                    Entry of technical parameters in order to check product
                    availability
                  </li>
                  <li>Technical data and product drawings</li>
                  <li>Bookmark fastening articles or send an inquiry</li>
                  <li>
                    Look easily for single components – a complete configuration
                    is not necessary
                  </li>
                  <li>Easy to use</li>
                </ul>
                <Text>
                  The LÜBBERING Team hopes you enjoy finding the right product.
                </Text>
              </div>
            )}

            {module == "TOOLBOX" && (
              <div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Are you using LÜBBERING fastening or drilling systems? Then
                    sign up for a LÜBBERING TOOLBOX account and take advantage
                    of quick access to product drawings, documents and much
                    more. You can expand your product data with your own
                    document, photo or video files, then set up a team to share
                    them with.
                  </Text>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Are you a LÜBBERING sales partner? Then register in the
                    Partner Lounge. Here you will be able to manage your
                    order-related fastening and drilling systems. You will have
                    access to all relevant product data for enhanced customer
                    care.
                  </Text>
                </div>
                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>Overview of your fastening and drilling systems</li>
                  <li>Record the operation site of fastening systems</li>
                  <li>
                    Technical product data available anytime and everywhere
                  </li>
                  <li> Product view in 3D</li>
                  <li>Spare parts lists, parts lists</li>
                  <li>
                    Easy to handle spare parts procurement with shopping list
                  </li>
                  <li>
                    Preventive maintenance recommendations for your fastening
                    and drilling systems
                  </li>
                  <li>Time saving due to quick information flow</li>
                  <li>
                    Form teams and share product information with each other
                  </li>
                </ul>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Are you a LÜBBERING Partner? Then register in the PARTNER
                    LOUNGE. Here you will be able to manage your order-related
                    fastening or drilling systems as in MY TOOLBOX. You will
                    have access to all relevant product data for enhanced
                    customer care.
                  </Text>
                </div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    The LÜBBERING DIGITAL team hopes you enjoy filling up your
                    personal LÜBBERING toolbox.
                  </Text>
                </div>
              </div>
            )}

            {module == "PARTNER" && (
              <div>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    Are you a LÜBBERING end customer? Then register in My
                    Toolbox. Here you will be able to manage your fastening and
                    drilling systems.You will have access to all relevant
                    product data for enhanced customer care.
                  </Text>
                </div>

                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>Simple and clear order-related tool management</li>
                  <li>
                    An overview of product and order data - fastening systems
                    including drive unit or drilling systems
                  </li>
                  <li>
                    All technical product data available anytime and everywhere
                  </li>
                  <li>3D product views</li>
                  <li>Spare parts lists, parts lists</li>
                  <li>
                    Significant time saving through a fast flow of information
                  </li>
                  <li>Supports fast and competent customer service</li>
                  <li>
                    Form teams and share product information with each other
                  </li>
                </ul>
                <div style={{ marginTop: 10 }}>
                  <Text>
                    The LÜBBERING DIGITAL team hopes you enjoy using our Partner
                    Lounge for enhanced customer service.
                  </Text>
                </div>
              </div>
            )}

            {module == "ACADEMY" && (
              <div>
                <h4 style={{ marginTop: 10 }}>
                  {i18n.t<string>("ihreVorteile")}
                </h4>
                <ul style={{ marginTop: 10 }}>
                  <li>
                    Overview of the training courses offered by the LÜBBERING
                    Academy
                  </li>
                  <li>
                    Request training or workshops dates directly and receive a
                    quotation quickly
                  </li>
                  <li>
                    Personal access to extensive training material and videos
                  </li>
                  <li>Management of your own training certificates</li>
                  <li>Recommendation for refreshing training content</li>
                  <li>Expert knowledge directly from the manufacturer</li>
                </ul>
              </div>
            )}
          </div>
        )}
        <div style={{ marginTop: "10px" }}>
          <StackShim horizontal tokens={{ childrenGap: 10 }}>
            <Button icon={<ArrowLeftRegular />} onClick={() => navigate(-1)}>
              {i18n.t<string>("back")}
            </Button>
            <Button
              icon={isLoggedIn ? <ArrowRightRegular /> : <PersonKeyRegular />}
              iconPosition={isLoggedIn ? "after" : "before"}
              disabled={disable()}
              onClick={onClick}
              appearance="primary"
            >
              {isLoggedIn ? buttonText : i18n.t<string>("signIn")}
            </Button>
          </StackShim>
        </div>
      </div>
    </div>
  );
}

export default About;
